import { gql } from '@apollo/client';

export default gql`
  query CompanyHasPaymentSource {
    viewer {
      id
      billing {
        subscription {
          id
          paymentSourceOnFile
        }
      }
    }
  }
`;
